import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  city() {
    return faker.address.city();
  },

  name() {
    return faker.company.name();
  },

  street() {
    return faker.address.street();
  },

  zip() {
    return faker.address.zipCode('#####');
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
